// Data entry values (/data-entry-values). The values in the lists are stored
// values and are shown as typed.
const dataEntryValues = {
  page: {
    title: 'Data Entry Values',
    subtitle: 'The department, authorization role, income and expense values offered in forms.',
  },
  stats: {
    lists: 'Value Lists',
    listsShort: 'Lists',
    active: 'Active Values',
    activeShort: 'Active',
    passive: 'Passive Values',
    passiveShort: 'Passive',
    unsaved: 'Unsaved Lists',
    unsavedShort: 'Unsaved',
  },
  groups: {
    people: 'Employees and authorization',
    income: 'Income',
    expense: 'Expense management',
  },
  card: {
    active: '{{count}} active',
    passive: '{{count}} passive',
    unsaved: 'Unsaved changes',
    activeShort: 'Active',
    passiveShort: 'Passive',
    makePassive: 'Make passive (not selectable for new records)',
    makeActive: 'Make active',
    edit: 'Edit',
    doneEditing: 'Done editing',
    delete: 'Delete',
    save: 'Save',
    saving: 'Saving…',
  },
  validation: {
    duplicate: 'This value is already in the list.',
  },
  confirm: {
    deactivateTitle: 'Value in use',
    deleteTitle: 'Delete the value?',
    deactivate: 'Make passive',
    delete: 'Delete',
    cancel: 'Cancel',
  },
  toast: {
    loadError: 'Error loading {{name}}.',
    saved: '{{name}} saved successfully!',
    saveError: 'Error saving {{name}}: {{message}}',
    checkValues: 'Please check the values you entered.',
    checkError: 'Error checking where {{name}} are used.',
  },
  lists: {
    departments: {
      name: 'Departments',
      title: 'Employee Menu – Departments',
      helper: 'Edit the departments available for employees. Empty departments are not saved.',
      placeholder: 'Enter a department name',
      itemName: 'Department {{index}}',
      add: 'Add New',
      deactivated: 'Department made passive.',
      deleted: 'Department deleted.',
      inUse: 'This department ({{value}}) is assigned to employees. Make it passive instead of deleting it? Passive departments stay in the list but cannot be chosen for new employees.',
      deleteMessage: 'Delete the department “{{value}}”? The list is saved right away.',
    },
    roles: {
      name: 'Authorization roles',
      title: 'Authorization Roles',
      helper: 'Edit the authorization roles for system users. Empty roles are not saved.',
      placeholder: 'Enter a role name',
      itemName: 'Role {{index}}',
      add: 'Add New',
      deactivated: 'Role made passive.',
      deleted: 'Role deleted.',
      inUse: 'This role ({{value}}) is assigned to users. Make it passive instead of deleting it? Passive roles stay in the list but cannot be chosen for new users.',
      deleteMessage: 'Delete the role “{{value}}”? The list is saved right away.',
    },
    incomeSources: {
      name: 'Income sources',
      title: 'Income Sources',
      helper: 'Edit the income sources. Empty sources are not saved.',
      placeholder: 'Enter an income source',
      itemName: 'Income source {{index}}',
      add: 'Add New',
      deactivated: 'Income source made passive.',
      deleted: 'Income source deleted.',
      inUse: 'This income source ({{value}}) is used by budget records. Make it passive instead of deleting it? Passive income sources stay in the list but cannot be chosen for new records.',
      deleteMessage: 'Delete the income source “{{value}}”? The list is saved right away.',
    },
    incomeCategories: {
      name: 'Income categories',
      title: 'Income Categories',
      helper: 'Edit the income categories. Empty categories are not saved.',
      placeholder: 'Enter an income category',
      itemName: 'Income category {{index}}',
      add: 'Add New',
      deactivated: 'Income category made passive.',
      deleted: 'Income category deleted.',
      inUse: 'This income category ({{value}}) is used by budget records. Make it passive instead of deleting it? Passive income categories stay in the list but cannot be chosen for new records.',
      deleteMessage: 'Delete the income category “{{value}}”? The list is saved right away.',
    },
    expenseSources: {
      name: 'Expense sources',
      title: 'Expense Sources',
      helper: 'Edit the expense sources; changes are written with “Save”.',
      placeholder: 'Expense source',
      itemName: 'Expense source {{index}}',
      add: 'Add Expense Source',
    },
    expenseTypes: {
      name: 'Expense types',
      title: 'Expense Types',
      helper: 'Edit the expense types; changes are written with “Save”.',
      placeholder: 'Expense type',
      itemName: 'Expense type {{index}}',
      add: 'Add Expense Type',
    },
    expenseCategories: {
      name: 'Expense categories',
      title: 'Expense Categories',
      helper: 'Edit the expense categories; changes are written with “Save”.',
      placeholder: 'Expense category',
      itemName: 'Expense category {{index}}',
      add: 'Add Expense Category',
    },
  },
};

export default dataEntryValues;
